<template>
  <div class="menu_box">
    <!-- :default-active="currentPath"  $router.currentRoute.fullPath-->
    <el-menu :default-active="currentPath" :unique-opened="true" class="el-menu-vertical-demo" @open="handleOpen"
      @close="handleClose" @select="selectMenu" background-color="#f2f5fd" text-color="#666"
      active-text-color="#29d894">
      <div class="nav_log_box">
        <img class="logo_img" v-if="webLogo" :src="webLogo" alt="" srcset="">
        <div class="logo_word">{{companyName}}</div>
      </div>
      <div class="search_box">
        <div class="s_input">
          <el-input v-model="menuName" prefix-icon="el-icon-search" placeholder="请输入菜单名称" @input="changeSearch"
            clearable @blur="searchSuccess=false" @focus="searchSuccess=true"></el-input>
          <div class="result_box" v-if="menuName.length>0&&searchSuccess">
            <div class="res_item" v-for="(item,index) in searchMenuList" :key="index" @mousedown="jumpSearch(item.url)">
              {{ item.name }}
            </div>
            <div class="no_menu" v-if="searchMenuList.length==0&&sOver">
              <i class="el-icon-warning-outline" style="margin-right: 5px;"></i> 没有该菜单~
            </div>
          </div>
        </div>
      </div>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-s-home"></i>
          <span>游戏推广</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item.url" v-for="(item,index) in homeNav" :key="item.url"
            @click="jumpPage(item.url)">{{ item.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-s-help"></i>
          <span slot="title">代充管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item.url" v-for="(item,index) in sysNav" :key="item.url"
            @click="jumpPage(item.url)">{{ item.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span slot="title">数据应用</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item.url" v-for="(item,index) in datasNav" :key="item.url"
            @click="jumpPage(item.url)">{{ item.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span slot="title">服务应用</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item.url" v-for="(item,index) in serviceNav" :key="item.url"
            @click="jumpPage(item.url)">{{ item.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-coin"></i>
          <span slot="title">提现管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item.url" v-for="(item,index) in cashNav" :key="index"
            @click="jumpPage(item.url)">{{ item.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="6">
        <template slot="title">
          <i class="el-icon-orange"></i>
          <span slot="title">常用功能</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item.url" v-for="(item,index) in useMenu" :key="index"
            @click="jumpPage(item.url)">{{ item.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
  import {
    serveList,
    sysList,
    dataList,
    cashList
  } from "@/utils/menu";
  export default {
    data() {
      return {
        // currentPath: '',
        menuName: '',
        searchMenuList: [],
        searchSuccess: false,
        sOver: false
      }
    },
    props: {
      webLogo: {
        default: ''
      },
      companyName: {
        default: ''
      },
      homeNav: {
        default: []
      },
      serviceNav: {
        default: []
      },
      sysNav: {
        default: []
      },
      datasNav: {
        default: []
      },
      cashNav: {
        default: []
      },
      useMenu: {
        default: []
      },
      currentPath: {
        default: ''
      }
    },
    mounted() {
      // let index = window.location.href.lastIndexOf('/')
      // this.currentPath = window.location.href.split('#')[1]
    },
    watch: {
      // $route(to, from) {
      //   console.log(to)
      //   this.currentPath = to.path
      //}
    },
    methods: {
      selectMenu(index, indexPath) {
        // console.log(index, indexPath)
      },
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
      jumpPage(v) {
        if (v == '/home/substitute') {
          this.$emit('cdr')
          return
        }
        this.$router.push(v);
      },
      changeSearch(v) {
        this.searchMenuList = []
        this.sOver = false
        this.$tools.debounce(() => {
          if (v.length > 0) {
            let arr = []
            let allMenu = [...this.homeNav, ...this.serviceNav, ...this.sysNav, ...this.cashNav, ...this.datasNav]
            for (let i = 0; i < allMenu.length; i++) {
              if (allMenu[i].name.indexOf(this.menuName) >= 0) {
                arr.push(allMenu[i])
              }
            }
            this.searchMenuList = arr
            this.searchSuccess = true
            this.sOver = true
          }
        }, 600)()
      },
      jumpSearch(v) {
        if (v == '/home/substitute') {
          this.$emit('cdr')
          return
        }
        this.menuName = ''
        this.$router.push({
          path: v
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .menu_box::-webkit-scrollbar {
    display: none;
  }

  .menu_box {
    height: 100vh;
    background: #f2f5fd;
    // background: #c2f7e3;
    width: 200px;
    overflow: auto;
    -ms-overflow-style: none;
    /* IE和Edge浏览器 */
    scrollbar-width: none;

    /* Firefox */
    .el-menu-vertical-demo {
      width: 200px;
    }

    .nav_log_box {
      display: flex;
      align-items: center;
      width: 200px;
      cursor: pointer;
      padding-left: 15px;
      box-sizing: border-box;
      margin-top: 15px;

      .logo_img {
        width: 40px;
        height: 40px;
      }

      .logo_word {
        font-size: 16px;
        font-weight: 700;
        color: #29D894;
        margin-left: 10px;
      }
    }
  }

  .search_box {
    margin-top: 15px;
    display: flex;
    align-items: center;

    .s_input {
      position: relative;
      padding: 0 10px;
      box-sizing: border-box;

      /deep/ .el-input__inner {
        background: #f2f5fd;
        border: none;
        border-bottom: 1px solid #666;
        color: #666;
      }

      .result_box {
        position: absolute;
        z-index: 99;
        left: 0;
        top: 45px;
        background-color: white;
        border: 1px solid #e9f1f5;
        border-radius: 3px;
        width: 200px;
        box-sizing: border-box;

        .no_menu {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
          font-size: 14px;
          color: #666;
        }

        .res_item {
          height: 30px;
          line-height: 30px;
          padding-left: 10px;
          cursor: pointer;
          box-sizing: border-box;
          color: #666;
          font-size: 14px;

          &:hover {
            background-color: #a9efd4;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/component/left_menu.vue